import LozadHelper from '@/services/helpers/LozadHelper.js'

export default {
  install(app) {
    app.config.globalProperties.hitLozad = () => {
      LozadHelper.hitLozad()
    }
  }
}
